<template>
	<modal
		:id="ref"
		:ref="ref"
		:closeProp="close"
		:title="
			'Submission #' + datas['id'] + ': ' + datas['form_name'] + ' ' + datas['form_lastname']
		"
		:id_donor="'id_donor'"
	>
		<div class="row">
			<div
				v-for="(value, key) in fixDatasToPrint"
				:key="key"
				class="col-4"
				style="margin-bottom: 25px"
			>
				<p style="color:#616161; font-size: 13px;">{{ key.toUpperCase() }}</p>
				<span v-if="value != null" style="color:black; font-size: 1rem;">{{ value }}</span>
				<span v-else style="color:lightslategray; font-size: 1rem; font-style: italic;"
					>Nessun valore</span
				>
			</div>
		</div>

		<div>
			<p style="color:#006ba6; font-size: 15px; font-weight: bold; padding-bottom: 5px;">
				Form
			</p>
			<div class="row">
				<div
					v-for="(value, key) in this.datas['form']"
					:key="key"
					class="col-4"
					style="margin-bottom: 25px"
				>
					<div v-if="!['privacy', 'donor_id', 'updated'].includes(key)">
						<p style="color:#616161; font-size: 13px;">{{ key.toUpperCase() }}</p>
						<span v-if="value != null" style="color:black; font-size: 1rem;">{{
							value
						}}</span>
						<span
							v-else
							style="color:lightslategray; font-size: 1rem; font-style: italic;"
							>Nessun valore</span
						>
					</div>
				</div>
			</div>
		</div>

		<div>
			<p style="color:#006ba6; font-size: 15px; font-weight: bold; padding-bottom: 5px;">
				Donazioni
			</p>
			<div class="row">
				<div
					v-for="(value, key) in this.datas['donazione']"
					:key="key"
					class="col-4"
					style="margin-bottom: 25px"
				>
					<p style="color:#616161; font-size: 13px;">{{ key.toUpperCase() }}</p>
					<span v-if="value != null" style="color:black; font-size: 1rem;">{{
						value
					}}</span>
					<span v-else style="color:lightslategray; font-size: 1rem; font-style: italic;"
						>Nessun valore</span
					>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
export default {
	data: () => ({
		ref: 'requests_modal',
		refForm: '',
		urlupdate: '',
		id: '',
		datas: {},
	}),
	props: {
		reftable: {
			type: String,
			default: '',
			required: false,
		},
	},

	computed: {
		fixDatasToPrint: function() {
			let new_datas = {
				ID: this.datas['id'],
				'Nome Source': this.datas['source_name'],
				'Data di Invio': this.datas['created_at'],
			}
			return new_datas
		},
	},

	created: function() {
		this.refForm = this.ref + 'DataForm'
	},

	methods: {
		close: function() {
			this.assignData({})
			this.urlupdate = ''

			this.$refs[this.ref].close()
		},
		open: function(data) {
			if (!!data && typeof data === 'object') {
				if (!!data.urlupdate) this.urlupdate = data.urlupdate
				if (!!data.datas) this.assignData(data.datas)
			} else if (!!data && Array.isArray(data)) {
				this.assignData(data)
			} else {
				this.assignData({})
			}

			this.$refs[this.ref].open()
			//console.log(Object.keys(this.datas))
			for (const key in this.datas) {
				console.log(`${key} -> ${this.datas[key]} ; `)
			}
		},

		//Prende i valori della riga
		getValue: function(key, defaultValue) {
			if (key === '') return this.datas
			else if (!!this.datas[key]) return this.datas[key]
			else if (this.datas[key] === 0 || this.datas[key] === '0' || this.datas[key] === false)
				return this.datas[key]
			else if (!!defaultValue) return defaultValue
			else return ''
		},

		assignData: function(datas) {
			if (!datas) return false

			if (!!Object.keys(datas).length) {
				this.datas = datas
				if (!!datas.id) this.id = datas.id
			} else {
				this.datas = {}
				this.id = ''
			}
		},

		format_json: function(data) {
			var s = ''
			for (var key in data) {
				var value = data[key]
				s = s + key.toUpperCase() + ': ' + value + ', '
			}

			return s.slice(0, -2)
		},
	},
}
</script>
